import React, { FunctionComponent, SVGProps } from 'react';

import styled from 'styled-components';
import LockIcon from '../lock';

export interface CircleLockIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  onClick?: () => void;
}

export const CircleLockIcon: FunctionComponent<CircleLockIconProps> = ({
  className,
  onClick,
}) => {
  return (
    <div className={className} onClick={onClick}>
      <LockIcon />
    </div>
  );
};

export default styled(CircleLockIcon)`
  background: #2c2c2e;
  border-radius: 50%;
  text-align: center;
  padding: 6px 8px;
`;
